export const employeeAndManagerLeaderConstants = {
    GET_SUCCESS: "GET_EMPLOYEE_AND_MANAGER_LEADER_SUCCESS",
    GET_FAILURE: "GET_EMPLOYEE_AND_MANAGER_LEADER_FAILURE",
};

export const leaveTypesConstants = {
    GET_SUCCESS: "GET_LEAVE_TYPES_SUCCESS",
    GET_FAILURE: "GET_LEAVE_TYPES__FAILURE",
};

export const availableTimeConstants = {
    GET_SUCCESS: "GET_AVAILABLE_TIME_SUCCESS",
    GET_FAILURE: "GET_AVAILABLE_TIME_FAILURE",
    DELETE: "DELETE_AVAILABLE_TIME",
};

export const createLeaveDayConstants = {
    ADD_SUCCESS: "CREATE_LEAVE_DAY_SUCCESS",
    ADD_FAILURE: "CREATE_LEAVE_DAY_FAILURE",
    DELETE: "DELETE_ERROR_CODE",
    ADD_LOADING: "ADD_LOADING",
};
